<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";

  export let onLeaveEditMode: () => void;
  export let onSubmit: (newAccountNumber: string) => Promise<{ error?: string }>;

  let newAccountNumber: string = "";
  let error = null;

  const clear = () => {
    newAccountNumber = "";
    error = null;
  };

  const leaveEditMode = () => {
    clear();
    onLeaveEditMode();
  };

  const onSubmitClick = async () => {
    const result = await onSubmit(newAccountNumber);

    if (result.error) {
      error = result.error;
    } else {
      leaveEditMode();
    }
  };

  let submitDisabled;

  $: {
    submitDisabled = newAccountNumber.trim().length === 0;
  }

</script>

<div class="fizz-stack-8">
  <label class="fizz-label fizz-stack-4" for="input-account-number">Account number</label>
  <input
    type="text"
    id="input-account-number"
    name="input-account-number"
    placeholder=""
    class="fizz-input-text fizz-stack-8 fizz-full-width"
    class:fizz-input-error={Boolean(error)}
    bind:value={newAccountNumber}
  />
  {#if error}
    <p class="fizz-text-urgent fizz-flex-row-4">
      <Icon type="Info" />
      <span>{error}</span>
    </p>
  {/if}
</div>
<div class="fizz-flex-row-12 fizz-justify-end">
  <button on:click={leaveEditMode} class="fizz-button fizz-button-small">Cancel</button>
  <button
    disabled={submitDisabled}
    on:click={onSubmitClick}
    class="fizz-button-secondary fizz-button-small">Submit</button
  >
</div>
